import { updatesItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '新片上线': 'bg-primary-100 text-primary-700',
  '专题更新': 'bg-accent-100 text-accent-700',
  '里程碑': 'bg-secondary-100 text-secondary-700',
  '片库更新': 'bg-primary-100 text-primary-700',
  '系统公告': 'bg-secondary-100 text-secondary-700',
  '功能更新': 'bg-accent-100 text-accent-700',
  '活动': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          麻花影院的最新影片上线、功能更新与平台动态
        </p>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden md:block"></div>
          <div className="space-y-6">
            {updatesItems.map((item) => (
              <div key={item.id} className="flex gap-4 md:gap-6 relative">
                <div className="hidden md:flex w-10 h-10 rounded-full bg-background-50 border-2 border-primary-200 flex-shrink-0 items-center justify-center z-10 mt-0.5">
                  <div className="w-2 h-2 rounded-full bg-primary-400"></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span
                      className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                        tagColors[item.tag] || 'bg-background-200 text-foreground-500'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-800 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}